import { render, staticRenderFns } from "./DesignDetails.vue?vue&type=template&id=2f3b1ba8&scoped=true"
import script from "./DesignDetails.vue?vue&type=script&lang=js"
export * from "./DesignDetails.vue?vue&type=script&lang=js"
import style0 from "./DesignDetails.vue?vue&type=style&index=0&id=2f3b1ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b1ba8",
  null
  
)

export default component.exports